import(/* webpackMode: "eager", webpackExports: ["ClientApp"] */ "/Users/chennengmin/Documents/YIL/yiling-ai-platform-full/open-design-main/apps/web/app/[[...slug]]/client-app.tsx");
